export default __webpack_public_path__ + "static/media/icon-01.dbdf9f48.svg";